"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _reactRedux = require("react-redux");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _Badge2 = _interopRequireDefault(require("angieslist-react-components/lib/Badge"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

var _hr, _Badge, _hr2, _hr3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var activityLocation = 'Leads Auth Header';

var AngiLeadsLeftSideBarItems = function AngiLeadsLeftSideBarItems(_ref) {
  var angiLeadsProperties = _ref.angiLeadsProperties,
      expandedSubNav = _ref.expandedSubNav,
      leadsNotificationCount = _ref.leadsNotificationCount,
      openSubNav = _ref.openSubNav,
      spId = _ref.spId,
      isAngiLeadsAdmin = _ref.isAngiLeadsAdmin;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "separator-bottom-grey"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "side-menu-main-row-wrapper side-menu-main-row-flex-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 8,
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Leads",
    href: _urlCatalog["default"].office.leads.leadsBoard(spId),
    id: "unified-header-sidebar-nav--leads"
  }, "Leads"))), leadsNotificationCount && leadsNotificationCount > 0 ? /*#__PURE__*/_react["default"].createElement(_Badge2["default"], {
    bsStyle: "danger",
    className: "unified-header-sidebar-nav--notification unified-header-sidebar-nav--notification-leads style={{ marginLeft: '-14px' }}"
  }, leadsNotificationCount) : null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    className: "unified-header-sidebar-nav--divider-dropdown"
  }, _hr || (_hr = /*#__PURE__*/_react["default"].createElement("hr", null)), /*#__PURE__*/_react["default"].createElement("i", {
    id: "unified-header-side-bar--sub-nav-leads--dropdown",
    tabIndex: 0,
    role: "button",
    className: "icon ".concat(expandedSubNav === 'leads' ? 'icon-up-open' : 'icon-down-open'),
    onClick: function onClick() {
      return openSubNav('leads');
    },
    onKeyDown: function onKeyDown() {
      return openSubNav('leads');
    }
  }))), expandedSubNav === 'leads' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header-side-bar--sub-nav"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "All leads",
    href: _urlCatalog["default"].office.leads.leadsBoard(spId),
    id: "unified-header-side-bar--sub-nav--all-leads",
    className: "unified-header-side-bar--sub-nav-item unified-header-side-bar--first-sub-nav-item"
  }, "All leads")))), angiLeadsProperties.instantBookingEnabled ? /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Appointments",
    href: _urlCatalog["default"].office.leads.appointments(spId),
    id: "unified-header-side-bar--sub-nav--appointments",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Appointments")))) : null, isAngiLeadsAdmin && angiLeadsProperties.showLeadFlow ? /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Manage lead flow",
    href: _urlCatalog["default"].office.leads.manageLeads(spId),
    id: "unified-header-side-bar--sub-nav-manage-lead-flow",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Manage lead volume")))) : null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Coverage area",
    href: _urlCatalog["default"].office.leads.serviceArea(spId),
    id: "unified-header-side-bar--sub-nav-service-area",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Service locations")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Services",
    href: _urlCatalog["default"].office.leads.servicesOffered(spId),
    id: "unified-header-side-bar--sub-nav-services",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Services & tasks"))))) : null), angiLeadsProperties.showOpportunityLeadsNavLink && isAngiLeadsAdmin ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "separator-bottom-grey"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "side-menu-main-row-wrapper side-menu-main-row-flex"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 4,
    className: "side-menu-leads-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Opportunities",
    href: _urlCatalog["default"].office.leads.opportunities(spId),
    id: "unified-header-sidebar-nav--opportunities"
  }, "Opportunities"))), angiLeadsProperties.hasOpportunityNotifications ? _Badge || (_Badge = /*#__PURE__*/_react["default"].createElement(_Badge2["default"], {
    bsStyle: "danger",
    className: "unified-header-sidebar-nav--notification"
  })) : null)) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "separator-bottom-grey"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "side-menu-main-row-wrapper side-menu-main-row-flex-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 8,
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Reviews",
    href: _urlCatalog["default"].office.leads.reviews(spId),
    id: "unified-header-sidebar-nav--reviews"
  }, "Reviews"))), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    className: "unified-header-sidebar-nav--divider-dropdown"
  }, _hr2 || (_hr2 = /*#__PURE__*/_react["default"].createElement("hr", null)), /*#__PURE__*/_react["default"].createElement("i", {
    id: "unified-header-side-bar--sub-nav-reviews--dropdown",
    tabIndex: 0,
    role: "button",
    className: "icon ".concat(expandedSubNav === 'reviews' ? 'icon-up-open' : 'icon-down-open'),
    onClick: function onClick() {
      return openSubNav('reviews');
    },
    onKeyDown: function onKeyDown() {
      return openSubNav('reviews');
    }
  }))), expandedSubNav === 'reviews' ? [/*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header-side-bar--sub-nav",
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "All reviews",
    href: _urlCatalog["default"].office.leads.reviews(spId),
    id: "unified-header-side-bar--sub-nav--all-reviews",
    className: "unified-header-side-bar--sub-nav-item unified-header-side-bar--first-sub-nav-item"
  }, "All reviews"))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header-side-bar--sub-nav",
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Request reviews",
    href: _urlCatalog["default"].office.leads.requestReviews(spId),
    id: "unified-header-side-bar--sub-nav--request-reviews",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Request reviews"))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header-side-bar--sub-nav",
    key: "2"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Feedback",
    href: _urlCatalog["default"].office.leads.requestFeedback(spId),
    id: "unified-header-side-bar--sub-nav--feedback",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Feedback")))))] : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "separator-bottom-grey margin-b-15"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    className: "side-menu-main-row-wrapper side-menu-main-row-flex"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 4,
    className: "side-menu-right-margin-full"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "My business",
    href: _urlCatalog["default"].office.leads.businessSettings(spId),
    id: "unified-header-sidebar-nav--my-business"
  }, "My business"))), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    className: "unified-header-sidebar-nav--divider-dropdown"
  }, _hr3 || (_hr3 = /*#__PURE__*/_react["default"].createElement("hr", null)), /*#__PURE__*/_react["default"].createElement("i", {
    id: "unified-header-side-bar--sub-nav-my-business--dropdown",
    tabIndex: 0,
    role: "button",
    className: "icon ".concat(expandedSubNav === 'myBusiness' ? 'icon-up-open' : 'icon-down-open'),
    onClick: function onClick() {
      return openSubNav('myBusiness');
    },
    onKeyDown: function onKeyDown() {
      return openSubNav('myBusiness');
    }
  }))), expandedSubNav === 'myBusiness' ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "unified-header-side-bar--sub-nav"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Settings",
    href: _urlCatalog["default"].office.leads.businessSettings(spId),
    id: "unified-header-side-bar--sub-nav--settings",
    className: "unified-header-side-bar--sub-nav-item unified-header-side-bar--first-sub-nav-item"
  }, "Business profile")))), isAngiLeadsAdmin && angiLeadsProperties.showMonthlyBudget ? [/*#__PURE__*/_react["default"].createElement(_Row["default"], {
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Coverage area",
    href: _urlCatalog["default"].office.leads.modifySpendTarget(spId),
    id: "unified-header-side-bar--sub-nav--monthly-budget",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Monthly budget")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Billing and payments",
    href: _urlCatalog["default"].office.leads.billingAndPayments(spId),
    id: "unified-header-side-bar--sub-nav--billing-and-payments",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Billing and payments"))))] : null, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Notification preferences",
    href: _urlCatalog["default"].office.leads.commPreferences(spId),
    id: "unified-header-side-bar--sub-nav--notification-preferences",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Notification preferences")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "App integrations",
    href: _urlCatalog["default"].office.account.appIntegrations(spId),
    id: "unified-header-side-bar--sub-nav--app-integrations",
    className: "unified-header-side-bar--sub-nav-item"
  }, "App integrations")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Manage team",
    href: _urlCatalog["default"].office.leads.manageTeam(spId),
    id: "unified-header-side-bar--sub-nav--manage-team",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Manage team")))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-description": "Connected numbers",
    href: _urlCatalog["default"].office.leads.connectedNumbers(spId),
    id: "unified-header-side-bar--sub-nav--connected-numbers",
    className: "unified-header-side-bar--sub-nav-item"
  }, "Connected numbers"))))) : null));
};

var _default = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
}), // eslint-disable-next-line no-unused-vars
(0, _reactRedux.connect)(function (state, props) {
  return {};
}, _objectSpread({}, _angieslistAppPlatform.analyticsActions)), _pure["default"])(AngiLeadsLeftSideBarItems);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/angiLeadsLeftSideBarItems.js
// module id = 3667
// module chunks = 25